<section class="news-page">
  <div class="news-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1>News & Promotions</h1>
      <p>Latest platform updates, campaigns, events and community highlights.</p>
    </div>
  </div>

  <div class="news-content">
    <p class="state" *ngIf="isLoading">Loading news and promotions...</p>
    <p class="state error" *ngIf="!isLoading && errorMessage">{{ errorMessage }}</p>
    <section class="empty-state" *ngIf="!isLoading && !errorMessage && !featuredItem && newsItems.length === 0 && promotionsItems.length === 0">
      <div class="empty-icon" aria-hidden="true">
        <span class="dot dot-one"></span>
        <span class="dot dot-two"></span>
      </div>
      <h2>No News & Promotions Found</h2>
      <p>{{ emptyMessage || 'There are no current updates right now. Check back soon for fresh stories and campaigns.' }}</p>
      <div class="empty-actions">
        <button type="button" class="empty-btn primary" (click)="retryLoad()">Refresh</button>
        <a routerLink="/games" class="empty-btn ghost">Browse Games</a>
      </div>
    </section>

    <article class="featured-card" *ngIf="!isLoading && !errorMessage && featuredItem">
      <div class="featured-media">
        <img [src]="featuredItem.imageUrl" [alt]="featuredItem.title" loading="lazy">
      </div>
      <div class="featured-body">
        <span class="badge">{{ featuredItem.type }}</span>
        <h2>{{ featuredItem.title }}</h2>
        <p class="meta">{{ featuredItem.publishedDate | date:'MMMM y' }}</p>
        <p>{{ featuredItem.summary }}</p>
        <a [routerLink]="['/news-promotions', featuredItem.id]" class="read-more">Read full story</a>
      </div>
    </article>

    <section class="list-block" *ngIf="!isLoading && !errorMessage && promotionsItems.length > 0">
      <h3>Promotions</h3>
      <div class="promotions-list">
        <article class="promotion-banner" *ngFor="let item of promotionsItems">
          <img [src]="item.imageUrl" [alt]="item.title" loading="lazy">
          <div class="promotion-overlay">
            <span class="badge">{{ item.type }}</span>
            <h4>{{ item.title }}</h4>
            <p>{{ item.summary }}</p>
            <a [routerLink]="['/news-promotions', item.id]" class="read-more">View promotion</a>
          </div>
        </article>
      </div>
    </section>

    <section class="list-block" *ngIf="!isLoading && !errorMessage && newsItems.length > 0">
      <h3>News</h3>
      <div class="news-grid">
        <article class="news-card" *ngFor="let item of newsItems">
          <div class="news-image-wrap">
            <img [src]="item.imageUrl" [alt]="item.title" loading="lazy">
          </div>
          <div class="news-card-body">
            <div class="top-row">
              <span class="badge">{{ item.type }}</span>
              <span class="meta">{{ item.publishedDate | date:'MMM y' }}</span>
            </div>
            <h4>{{ item.title }}</h4>
            <p>{{ item.summary }}</p>
            <a [routerLink]="['/news-promotions', item.id]" class="read-more">Read more</a>
          </div>
        </article>
      </div>
    </section>
  </div>
</section>
